import { useAppSelector } from './useAppSelector';
import { UserRoles } from '../services/src/service/types/users';

export const useUserPermissions = () => {
  const { loggedInUser } = useAppSelector(({ global }) => global);
  const isSyteAdmin = loggedInUser?.role === UserRoles.SyteAdmin;
  return { isSyteAdmin };
};
